import type { CSSProperties } from 'react'

// สไตล์ของแถบ/ปุ่มลอย/ป๊อปอัปที่มาจาก "สีเดียว" ที่แอดมินเลือก — API รับประกันว่าตัวอักษรขาวบนสีนี้อ่านชัด
// หน้าตาต้องตรงกับตัวอย่างในหลังบ้าน (jos-cowork-backoffice: Order/components/promoShared.tsx)

const clamp = (n: number) => Math.max(0, Math.min(255, Math.round(n)))
const hexToRgb = (hex: string): [number, number, number] => {
  const h = hex.replace('#', '')
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)]
}
const rgbToHex = (r: number, g: number, b: number) => '#' + [r, g, b].map((v) => clamp(v).toString(16).padStart(2, '0')).join('')

/** amt −1..1 (มืดลง..สว่างขึ้น) */
export const shade = (hex: string, amt: number): string => {
  const [r, g, b] = hexToRgb(hex)
  return amt >= 0
    ? rgbToHex(r + (255 - r) * amt, g + (255 - g) * amt, b + (255 - b) * amt)
    : rgbToHex(r * (1 + amt), g * (1 + amt), b * (1 + amt))
}

export const isHex = (v: unknown): v is string => typeof v === 'string' && /^#[0-9A-Fa-f]{6}$/.test(v)
export const safeColor = (v: unknown, fallback = '#0A7D55'): string => (isHex(v) ? v : fallback)

export const gradientOf = (hex: string): string => `linear-gradient(120deg, ${shade(hex, -0.28)}, ${hex} 55%, ${shade(hex, 0.18)})`
export const barStyle = (hex: string): CSSProperties => ({ backgroundImage: gradientOf(safeColor(hex)) })

const hexPattern = (stroke: string) =>
  `url("data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='56' height='98' viewBox='0 0 56 98'><path d='M28 66L0 50V16L28 0l28 16v34L28 66zm0 32L0 82V50' fill='none' stroke='${stroke}' stroke-opacity='0.18' stroke-width='1.5'/></svg>`
  )}")`

/** ลายพื้นหลังของป๊อปอัป (ชุดสำเร็จรูป: hex | dots | wave) */
export const patternStyle = (pattern: string, hex: string): CSSProperties => {
  const c = safeColor(hex, '#5B52E5')
  if (pattern === 'dots') {
    return { backgroundImage: `radial-gradient(rgba(255,255,255,.22) 1.5px, transparent 1.5px), ${gradientOf(c)}`, backgroundSize: '18px 18px, auto' }
  }
  if (pattern === 'wave') return { backgroundImage: gradientOf(c) }
  return { backgroundImage: `${hexPattern('#ffffff')}, ${gradientOf(c)}` }
}
